// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_create_room.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { LockSettings } from "./plugnmeet_gen_token_pb";
import { file_plugnmeet_gen_token } from "./plugnmeet_gen_token_pb";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { IngressInput } from "./plugnmeet_ingress_pb";
import { file_plugnmeet_ingress } from "./plugnmeet_ingress_pb";
import type { ActiveRoomInfo } from "./plugnmeet_auth_room_pb";
import { file_plugnmeet_auth_room } from "./plugnmeet_auth_room_pb";
import type { StatusCode } from "./plugnmeet_common_api_pb";
import { file_plugnmeet_common_api } from "./plugnmeet_common_api_pb";
import type { RecorderBotOptions } from "./plugnmeet_recording_pb";
import { file_plugnmeet_recording } from "./plugnmeet_recording_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_create_room.proto.
 */
export const file_plugnmeet_create_room: GenFile = /*@__PURE__*/
  fileDesc("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", [file_plugnmeet_gen_token, file_buf_validate_validate, file_plugnmeet_ingress, file_plugnmeet_auth_room, file_plugnmeet_common_api, file_plugnmeet_recording]);

/**
 * @generated from message plugnmeet.CreateRoomReq
 */
export type CreateRoomReq = Message<"plugnmeet.CreateRoomReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: optional uint32 empty_timeout = 2;
   */
  emptyTimeout?: number | undefined;

  /**
   * @generated from field: optional uint32 max_participants = 3;
   */
  maxParticipants?: number | undefined;

  /**
   * @generated from field: plugnmeet.RoomMetadata metadata = 4;
   */
  metadata?: RoomMetadata | undefined;
};

/**
 * Describes the message plugnmeet.CreateRoomReq.
 * Use `create(CreateRoomReqSchema)` to create a new message.
 */
export const CreateRoomReqSchema: GenMessage<CreateRoomReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 0);

/**
 * @generated from message plugnmeet.RoomMetadata
 */
export type RoomMetadata = Message<"plugnmeet.RoomMetadata"> & {
  /**
   * @generated from field: string room_title = 1;
   */
  roomTitle: string;

  /**
   * @generated from field: optional string welcome_message = 2;
   */
  welcomeMessage?: string | undefined;

  /**
   * @generated from field: bool is_recording = 3;
   */
  isRecording: boolean;

  /**
   * @generated from field: bool is_active_rtmp = 4;
   */
  isActiveRtmp: boolean;

  /**
   * @generated from field: string parent_room_id = 5;
   */
  parentRoomId: string;

  /**
   * @generated from field: bool is_breakout_room = 6;
   */
  isBreakoutRoom: boolean;

  /**
   * @generated from field: optional string webhook_url = 7;
   */
  webhookUrl?: string | undefined;

  /**
   * @generated from field: uint64 started_at = 8 [jstype = JS_STRING];
   */
  startedAt: string;

  /**
   * @generated from field: optional string logout_url = 9;
   */
  logoutUrl?: string | undefined;

  /**
   * @generated from field: plugnmeet.RoomCreateFeatures room_features = 10;
   */
  roomFeatures?: RoomCreateFeatures | undefined;

  /**
   * @generated from field: plugnmeet.LockSettings default_lock_settings = 11;
   */
  defaultLockSettings?: LockSettings | undefined;

  /**
   * @generated from field: plugnmeet.CopyrightConf copyright_conf = 12;
   */
  copyrightConf?: CopyrightConf | undefined;

  /**
   * we'll use this as version control
   *
   * @generated from field: optional string metadata_id = 13;
   */
  metadataId?: string | undefined;

  /**
   * @generated from field: map<string, string> extra_data = 14;
   */
  extraData: { [key: string]: string };
};

/**
 * Describes the message plugnmeet.RoomMetadata.
 * Use `create(RoomMetadataSchema)` to create a new message.
 */
export const RoomMetadataSchema: GenMessage<RoomMetadata> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 1);

/**
 * @generated from message plugnmeet.RoomCreateFeatures
 */
export type RoomCreateFeatures = Message<"plugnmeet.RoomCreateFeatures"> & {
  /**
   * @generated from field: bool allow_webcams = 1;
   */
  allowWebcams: boolean;

  /**
   * @generated from field: bool mute_on_start = 2;
   */
  muteOnStart: boolean;

  /**
   * @generated from field: bool allow_screen_share = 3;
   */
  allowScreenShare: boolean;

  /**
   * deprecated use external_broadcasting_features
   *
   * @generated from field: optional bool allow_rtmp = 4 [deprecated = true];
   * @deprecated
   */
  allowRtmp?: boolean | undefined;

  /**
   * @generated from field: bool allow_view_other_webcams = 5;
   */
  allowViewOtherWebcams: boolean;

  /**
   * @generated from field: bool allow_view_other_users_list = 6;
   */
  allowViewOtherUsersList: boolean;

  /**
   * @generated from field: bool admin_only_webcams = 7;
   */
  adminOnlyWebcams: boolean;

  /**
   * @generated from field: optional uint64 room_duration = 8 [jstype = JS_STRING];
   */
  roomDuration?: string | undefined;

  /**
   * @generated from field: bool enable_analytics = 9;
   */
  enableAnalytics: boolean;

  /**
   * @generated from field: optional bool allow_virtual_bg = 10;
   */
  allowVirtualBg?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_raise_hand = 11;
   */
  allowRaiseHand?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_reactions = 27;
   */
  allowReactions?: boolean | undefined;

  /**
   * @generated from field: optional bool auto_gen_user_id = 12;
   */
  autoGenUserId?: boolean | undefined;

  /**
   * @generated from field: plugnmeet.RecordingFeatures recording_features = 13;
   */
  recordingFeatures?: RecordingFeatures | undefined;

  /**
   * @generated from field: plugnmeet.ChatFeatures chat_features = 14;
   */
  chatFeatures?: ChatFeatures | undefined;

  /**
   * @generated from field: plugnmeet.SharedNotePadFeatures shared_note_pad_features = 15;
   */
  sharedNotePadFeatures?: SharedNotePadFeatures | undefined;

  /**
   * @generated from field: plugnmeet.WhiteboardFeatures whiteboard_features = 16;
   */
  whiteboardFeatures?: WhiteboardFeatures | undefined;

  /**
   * @generated from field: plugnmeet.ExternalMediaPlayerFeatures external_media_player_features = 17;
   */
  externalMediaPlayerFeatures?: ExternalMediaPlayerFeatures | undefined;

  /**
   * @generated from field: plugnmeet.WaitingRoomFeatures waiting_room_features = 18;
   */
  waitingRoomFeatures?: WaitingRoomFeatures | undefined;

  /**
   * @generated from field: plugnmeet.BreakoutRoomFeatures breakout_room_features = 19;
   */
  breakoutRoomFeatures?: BreakoutRoomFeatures | undefined;

  /**
   * @generated from field: plugnmeet.DisplayExternalLinkFeatures display_external_link_features = 20;
   */
  displayExternalLinkFeatures?: DisplayExternalLinkFeatures | undefined;

  /**
   * @generated from field: plugnmeet.IngressFeatures ingress_features = 21;
   */
  ingressFeatures?: IngressFeatures | undefined;

  /**
   * @generated from field: plugnmeet.EndToEndEncryptionFeatures end_to_end_encryption_features = 22;
   */
  endToEndEncryptionFeatures?: EndToEndEncryptionFeatures | undefined;

  /**
   * @generated from field: plugnmeet.PollsFeatures polls_features = 23;
   */
  pollsFeatures?: PollsFeatures | undefined;

  /**
   * @generated from field: plugnmeet.InsightsFeatures insights_features = 24;
   */
  insightsFeatures?: InsightsFeatures | undefined;

  /**
   * @generated from field: plugnmeet.SipDialInFeatures sip_dial_in_features = 25;
   */
  sipDialInFeatures?: SipDialInFeatures | undefined;

  /**
   * next ID: 28
   *
   * @generated from field: plugnmeet.ExternalBroadcastingFeatures external_broadcasting_features = 26;
   */
  externalBroadcastingFeatures?: ExternalBroadcastingFeatures | undefined;
};

/**
 * Describes the message plugnmeet.RoomCreateFeatures.
 * Use `create(RoomCreateFeaturesSchema)` to create a new message.
 */
export const RoomCreateFeaturesSchema: GenMessage<RoomCreateFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 2);

/**
 * @generated from message plugnmeet.ChatFeatures
 */
export type ChatFeatures = Message<"plugnmeet.ChatFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_allow_file_upload = 2;
   */
  isAllowFileUpload: boolean;

  /**
   * @generated from field: repeated string allowed_file_types = 3;
   */
  allowedFileTypes: string[];

  /**
   * @generated from field: optional uint64 max_file_size = 4 [jstype = JS_STRING];
   */
  maxFileSize?: string | undefined;
};

/**
 * Describes the message plugnmeet.ChatFeatures.
 * Use `create(ChatFeaturesSchema)` to create a new message.
 */
export const ChatFeaturesSchema: GenMessage<ChatFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 3);

/**
 * @generated from message plugnmeet.SharedNotePadFeatures
 */
export type SharedNotePadFeatures = Message<"plugnmeet.SharedNotePadFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;

  /**
   * @generated from field: bool visible = 3;
   */
  visible: boolean;

  /**
   * @generated from field: string node_id = 4;
   */
  nodeId: string;

  /**
   * @generated from field: string host = 5;
   */
  host: string;

  /**
   * @generated from field: string note_pad_id = 6;
   */
  notePadId: string;

  /**
   * @generated from field: string read_only_pad_id = 7;
   */
  readOnlyPadId: string;
};

/**
 * Describes the message plugnmeet.SharedNotePadFeatures.
 * Use `create(SharedNotePadFeaturesSchema)` to create a new message.
 */
export const SharedNotePadFeaturesSchema: GenMessage<SharedNotePadFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 4);

/**
 * @generated from message plugnmeet.WhiteboardFeatures
 */
export type WhiteboardFeatures = Message<"plugnmeet.WhiteboardFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool visible = 2;
   */
  visible: boolean;

  /**
   * @generated from field: optional string preload_file = 3;
   */
  preloadFile?: string | undefined;

  /**
   * @generated from field: string whiteboard_file_id = 4;
   */
  whiteboardFileId: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: string file_path = 6;
   */
  filePath: string;

  /**
   * @generated from field: uint32 total_pages = 7;
   */
  totalPages: number;

  /**
   * @generated from field: optional uint64 max_allowed_file_size = 8 [jstype = JS_STRING];
   */
  maxAllowedFileSize?: string | undefined;
};

/**
 * Describes the message plugnmeet.WhiteboardFeatures.
 * Use `create(WhiteboardFeaturesSchema)` to create a new message.
 */
export const WhiteboardFeaturesSchema: GenMessage<WhiteboardFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 5);

/**
 * @generated from message plugnmeet.ExternalMediaPlayerFeatures
 */
export type ExternalMediaPlayerFeatures = Message<"plugnmeet.ExternalMediaPlayerFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;

  /**
   * @generated from field: optional string shared_by = 3;
   */
  sharedBy?: string | undefined;

  /**
   * @generated from field: optional string url = 4;
   */
  url?: string | undefined;
};

/**
 * Describes the message plugnmeet.ExternalMediaPlayerFeatures.
 * Use `create(ExternalMediaPlayerFeaturesSchema)` to create a new message.
 */
export const ExternalMediaPlayerFeaturesSchema: GenMessage<ExternalMediaPlayerFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 6);

/**
 * @generated from message plugnmeet.WaitingRoomFeatures
 */
export type WaitingRoomFeatures = Message<"plugnmeet.WaitingRoomFeatures"> & {
  /**
   * @generated from field: bool is_active = 1;
   */
  isActive: boolean;

  /**
   * @generated from field: string waiting_room_msg = 2;
   */
  waitingRoomMsg: string;
};

/**
 * Describes the message plugnmeet.WaitingRoomFeatures.
 * Use `create(WaitingRoomFeaturesSchema)` to create a new message.
 */
export const WaitingRoomFeaturesSchema: GenMessage<WaitingRoomFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 7);

/**
 * @generated from message plugnmeet.BreakoutRoomFeatures
 */
export type BreakoutRoomFeatures = Message<"plugnmeet.BreakoutRoomFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;

  /**
   * @generated from field: uint32 allowed_number_rooms = 3;
   */
  allowedNumberRooms: number;
};

/**
 * Describes the message plugnmeet.BreakoutRoomFeatures.
 * Use `create(BreakoutRoomFeaturesSchema)` to create a new message.
 */
export const BreakoutRoomFeaturesSchema: GenMessage<BreakoutRoomFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 8);

/**
 * @generated from message plugnmeet.DisplayExternalLinkFeatures
 */
export type DisplayExternalLinkFeatures = Message<"plugnmeet.DisplayExternalLinkFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;

  /**
   * @generated from field: optional string link = 3;
   */
  link?: string | undefined;

  /**
   * @generated from field: optional string shared_by = 4;
   */
  sharedBy?: string | undefined;
};

/**
 * Describes the message plugnmeet.DisplayExternalLinkFeatures.
 * Use `create(DisplayExternalLinkFeaturesSchema)` to create a new message.
 */
export const DisplayExternalLinkFeaturesSchema: GenMessage<DisplayExternalLinkFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 9);

/**
 * @generated from message plugnmeet.ExternalBroadcastingFeatures
 */
export type ExternalBroadcastingFeatures = Message<"plugnmeet.ExternalBroadcastingFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_allow_rtmp = 2;
   */
  isAllowRtmp: boolean;

  /**
   * @generated from field: optional plugnmeet.RecorderBotOptions recorder_bot_options = 3;
   */
  recorderBotOptions?: RecorderBotOptions | undefined;
};

/**
 * Describes the message plugnmeet.ExternalBroadcastingFeatures.
 * Use `create(ExternalBroadcastingFeaturesSchema)` to create a new message.
 */
export const ExternalBroadcastingFeaturesSchema: GenMessage<ExternalBroadcastingFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 10);

/**
 * @generated from message plugnmeet.RecordingFeatures
 */
export type RecordingFeatures = Message<"plugnmeet.RecordingFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_allow_cloud = 2;
   */
  isAllowCloud: boolean;

  /**
   * @generated from field: bool enable_auto_cloud_recording = 3;
   */
  enableAutoCloudRecording: boolean;

  /**
   * @generated from field: bool is_allow_local = 4;
   */
  isAllowLocal: boolean;

  /**
   * @generated from field: bool only_record_admin_webcams = 5;
   */
  onlyRecordAdminWebcams: boolean;

  /**
   * @generated from field: optional plugnmeet.RecorderBotOptions recorder_bot_options = 6;
   */
  recorderBotOptions?: RecorderBotOptions | undefined;
};

/**
 * Describes the message plugnmeet.RecordingFeatures.
 * Use `create(RecordingFeaturesSchema)` to create a new message.
 */
export const RecordingFeaturesSchema: GenMessage<RecordingFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 11);

/**
 * @generated from message plugnmeet.IngressFeatures
 */
export type IngressFeatures = Message<"plugnmeet.IngressFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: plugnmeet.IngressInput input_type = 2;
   */
  inputType: IngressInput;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string stream_key = 4;
   */
  streamKey: string;
};

/**
 * Describes the message plugnmeet.IngressFeatures.
 * Use `create(IngressFeaturesSchema)` to create a new message.
 */
export const IngressFeaturesSchema: GenMessage<IngressFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 12);

/**
 * @generated from message plugnmeet.EndToEndEncryptionFeatures
 */
export type EndToEndEncryptionFeatures = Message<"plugnmeet.EndToEndEncryptionFeatures"> & {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled: boolean;

  /**
   * @generated from field: bool included_chat_messages = 2;
   */
  includedChatMessages: boolean;

  /**
   * @generated from field: bool included_whiteboard = 3;
   */
  includedWhiteboard: boolean;

  /**
   * @generated from field: bool enabled_self_insert_encryption_key = 5;
   */
  enabledSelfInsertEncryptionKey: boolean;

  /**
   * internal fields
   *
   * @generated from field: optional string encryption_key = 4;
   */
  encryptionKey?: string | undefined;
};

/**
 * Describes the message plugnmeet.EndToEndEncryptionFeatures.
 * Use `create(EndToEndEncryptionFeaturesSchema)` to create a new message.
 */
export const EndToEndEncryptionFeaturesSchema: GenMessage<EndToEndEncryptionFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 13);

/**
 * @generated from message plugnmeet.PollsFeatures
 */
export type PollsFeatures = Message<"plugnmeet.PollsFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;
};

/**
 * Describes the message plugnmeet.PollsFeatures.
 * Use `create(PollsFeaturesSchema)` to create a new message.
 */
export const PollsFeaturesSchema: GenMessage<PollsFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 14);

/**
 * @generated from message plugnmeet.SipDialInFeatures
 */
export type SipDialInFeatures = Message<"plugnmeet.SipDialInFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * If true, the system will immediately prepare the room for SIP dial-in
   * by creating a dispatch rule and assigning a PIN upon creation.
   * If false, this must be done later via a separate API call.
   *
   * @generated from field: bool enable_dial_in_on_create = 2;
   */
  enableDialInOnCreate: boolean;

  /**
   * @generated from field: bool hide_phone_number = 3;
   */
  hidePhoneNumber: boolean;

  /**
   * all internal usage fields
   *
   * @generated from field: bool is_active = 4;
   */
  isActive: boolean;

  /**
   * @generated from field: repeated string phone_numbers = 5;
   */
  phoneNumbers: string[];

  /**
   * @generated from field: optional string pin = 6;
   */
  pin?: string | undefined;

  /**
   * @generated from field: optional string dispatch_rule_id = 7;
   */
  dispatchRuleId?: string | undefined;
};

/**
 * Describes the message plugnmeet.SipDialInFeatures.
 * Use `create(SipDialInFeaturesSchema)` to create a new message.
 */
export const SipDialInFeaturesSchema: GenMessage<SipDialInFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 15);

/**
 * @generated from message plugnmeet.InsightsFeatures
 */
export type InsightsFeatures = Message<"plugnmeet.InsightsFeatures"> & {
  /**
   * Allow/disallow all insights features for this room
   *
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: optional plugnmeet.InsightsTranscriptionFeatures transcription_features = 2;
   */
  transcriptionFeatures?: InsightsTranscriptionFeatures | undefined;

  /**
   * @generated from field: optional plugnmeet.InsightsChatTranslationFeatures chat_translation_features = 3;
   */
  chatTranslationFeatures?: InsightsChatTranslationFeatures | undefined;

  /**
   * @generated from field: optional plugnmeet.InsightsAIFeatures ai_features = 4;
   */
  aiFeatures?: InsightsAIFeatures | undefined;
};

/**
 * Describes the message plugnmeet.InsightsFeatures.
 * Use `create(InsightsFeaturesSchema)` to create a new message.
 */
export const InsightsFeaturesSchema: GenMessage<InsightsFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 16);

/**
 * @generated from message plugnmeet.InsightsTranscriptionFeatures
 */
export type InsightsTranscriptionFeatures = Message<"plugnmeet.InsightsTranscriptionFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: bool is_allow_translation = 2;
   */
  isAllowTranslation: boolean;

  /**
   * @generated from field: bool is_allow_speech_synthesis = 3;
   */
  isAllowSpeechSynthesis: boolean;

  /**
   * all internal usage fields
   *
   * @generated from field: bool is_enabled = 4;
   */
  isEnabled: boolean;

  /**
   * @generated from field: repeated string allowed_spoken_langs = 5;
   */
  allowedSpokenLangs: string[];

  /**
   * @generated from field: repeated string allowed_speech_users = 6;
   */
  allowedSpeechUsers: string[];

  /**
   * @generated from field: bool is_enabled_translation = 7;
   */
  isEnabledTranslation: boolean;

  /**
   * @generated from field: int32 max_selected_trans_langs = 8;
   */
  maxSelectedTransLangs: number;

  /**
   * @generated from field: repeated string allowed_trans_langs = 9;
   */
  allowedTransLangs: string[];

  /**
   * @generated from field: optional string default_subtitle_lang = 10;
   */
  defaultSubtitleLang?: string | undefined;

  /**
   * @generated from field: bool is_enabled_speech_synthesis = 11;
   */
  isEnabledSpeechSynthesis: boolean;
};

/**
 * Describes the message plugnmeet.InsightsTranscriptionFeatures.
 * Use `create(InsightsTranscriptionFeaturesSchema)` to create a new message.
 */
export const InsightsTranscriptionFeaturesSchema: GenMessage<InsightsTranscriptionFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 17);

/**
 * @generated from message plugnmeet.InsightsChatTranslationFeatures
 */
export type InsightsChatTranslationFeatures = Message<"plugnmeet.InsightsChatTranslationFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * all internal usage fields
   *
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled: boolean;

  /**
   * @generated from field: repeated string allowed_trans_langs = 3;
   */
  allowedTransLangs: string[];

  /**
   * @generated from field: int32 max_selected_trans_langs = 4;
   */
  maxSelectedTransLangs: number;

  /**
   * @generated from field: optional string default_lang = 5;
   */
  defaultLang?: string | undefined;
};

/**
 * Describes the message plugnmeet.InsightsChatTranslationFeatures.
 * Use `create(InsightsChatTranslationFeaturesSchema)` to create a new message.
 */
export const InsightsChatTranslationFeaturesSchema: GenMessage<InsightsChatTranslationFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 18);

/**
 * @generated from message plugnmeet.InsightsAIFeatures
 */
export type InsightsAIFeatures = Message<"plugnmeet.InsightsAIFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: optional plugnmeet.InsightsAITextChatFeatures ai_text_chat_features = 2;
   */
  aiTextChatFeatures?: InsightsAITextChatFeatures | undefined;

  /**
   * @generated from field: optional plugnmeet.InsightsAIMeetingSummarizationFeatures meeting_summarization_features = 3;
   */
  meetingSummarizationFeatures?: InsightsAIMeetingSummarizationFeatures | undefined;
};

/**
 * Describes the message plugnmeet.InsightsAIFeatures.
 * Use `create(InsightsAIFeaturesSchema)` to create a new message.
 */
export const InsightsAIFeaturesSchema: GenMessage<InsightsAIFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 19);

/**
 * @generated from message plugnmeet.InsightsAITextChatFeatures
 */
export type InsightsAITextChatFeatures = Message<"plugnmeet.InsightsAITextChatFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * all internal usage fields
   *
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled: boolean;

  /**
   * @generated from field: bool is_allowed_everyone = 3;
   */
  isAllowedEveryone: boolean;

  /**
   * @generated from field: repeated string allowed_user_ids = 4;
   */
  allowedUserIds: string[];
};

/**
 * Describes the message plugnmeet.InsightsAITextChatFeatures.
 * Use `create(InsightsAITextChatFeaturesSchema)` to create a new message.
 */
export const InsightsAITextChatFeaturesSchema: GenMessage<InsightsAITextChatFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 20);

/**
 * @generated from message plugnmeet.InsightsAIMeetingSummarizationFeatures
 */
export type InsightsAIMeetingSummarizationFeatures = Message<"plugnmeet.InsightsAIMeetingSummarizationFeatures"> & {
  /**
   * @generated from field: bool is_allow = 1;
   */
  isAllow: boolean;

  /**
   * @generated from field: string summarization_prompt = 2;
   */
  summarizationPrompt: string;

  /**
   * all internal usage fields
   *
   * @generated from field: bool is_enabled = 3;
   */
  isEnabled: boolean;
};

/**
 * Describes the message plugnmeet.InsightsAIMeetingSummarizationFeatures.
 * Use `create(InsightsAIMeetingSummarizationFeaturesSchema)` to create a new message.
 */
export const InsightsAIMeetingSummarizationFeaturesSchema: GenMessage<InsightsAIMeetingSummarizationFeatures> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 21);

/**
 * @generated from message plugnmeet.CopyrightConf
 */
export type CopyrightConf = Message<"plugnmeet.CopyrightConf"> & {
  /**
   * @generated from field: bool display = 1;
   */
  display: boolean;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message plugnmeet.CopyrightConf.
 * Use `create(CopyrightConfSchema)` to create a new message.
 */
export const CopyrightConfSchema: GenMessage<CopyrightConf> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 22);

/**
 * @generated from message plugnmeet.CreateRoomRes
 */
export type CreateRoomRes = Message<"plugnmeet.CreateRoomRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.ActiveRoomInfo room_info = 4;
   */
  roomInfo?: ActiveRoomInfo | undefined;
};

/**
 * Describes the message plugnmeet.CreateRoomRes.
 * Use `create(CreateRoomResSchema)` to create a new message.
 */
export const CreateRoomResSchema: GenMessage<CreateRoomRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_create_room, 23);

